import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { customerRegister } from '../services/api';
import { useCustomerAuth } from '../services/CustomerAuthContext';
import TermsAcceptance from '../components/TermsAcceptance';

function CustomerRegister() {
  const [form, setForm] = useState({ email: '', password: '', displayName: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const { loginCustomer } = useCustomerAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!form.displayName || !form.email || !form.password) { setError('All fields required'); return; }
    if (form.password.length < 8) { setError('Password must be 8+ characters'); return; }
    setShowTerms(true);
  };

  const handleAcceptTerms = async () => {
    setShowTerms(false);
    setLoading(true);
    try {
      const data = await customerRegister(form);
      loginCustomer(data.token, data.customer);
      navigate('/commissions');
    } catch (err) {
      setError(err.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page customer-auth">
      <div className="auth-card">
        <span className="auth-badge">Customer</span>
        <h2>Join Timber Summit</h2>
        <p className="auth-subtitle">Create an account to bid, collaborate, and commission custom pieces</p>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Display Name *" value={form.displayName} onChange={e => setForm({ ...form, displayName: e.target.value })} required />
          <input type="email" placeholder="Email *" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          <input type="password" placeholder="Password (8+ characters) *" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required minLength={8} />
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>
        <p className="auth-link">Already have an account? <Link to="/customer/login">Sign in</Link></p>
        <p className="auth-link">Are you a vendor? <Link to="/vendor/register">Register as vendor</Link></p>
      </div>
      {showTerms && <TermsAcceptance onAccept={handleAcceptTerms} onCancel={() => setShowTerms(false)} />}
    </div>
  );
}

export default CustomerRegister;
